import React from 'react'
import { Link } from 'react-router-dom'
import AuthUI from '@/components/auth/AuthUI'

const LoginPage: React.FC = () => {
  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">
          Welcome back
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600">
          Sign in to your account to continue
        </p>
      </div>

      {/* Supabase Auth UI */}
      <AuthUI view="sign_in" />
      
      {/* Sign up link */}
      <div className="text-center">
        <p className="text-sm text-gray-600">
          Don't have an account?{' '}
          <Link
            to="/auth/register"
            className="font-medium text-primary-600 hover:text-primary-500 transition-colors"
          >
            Sign up for free
          </Link>
        </p>
      </div>
    </div>
  )
}

export default LoginPage